import React from 'react';
import PropTypes from 'prop-types';
import type { BreadcrumbProps } from './Breadcrumb.types'
import Icon from '../icon/Icon'
import './breadcrumb.scss';

const Breadcrumb = ({ options }: BreadcrumbProps) => {
  const indexLast = options.length - 1;

  return (
    <div
      className="sb-breadcrumb"
      data-testid="sb-breadcrumb"
    >
      {options.map((option, index) => {
        const isActive = option.isActive ? 'sb-breadcrumb--active' : ''
        const isDisabled = option.isDisabled ? 'sb-breadcrumb--disabled' : ''

        return <div
          className={['sb-breadcrumb__item',
            isActive,
            isDisabled].join(' ')}
          key={`breadcrumb-${index}`}
          data-testid="sb-breadcrumb__item"
        >
          <span
            className="sb-breadcrumb__text"
            data-testid="sb-breadcrumb__text"
          >
            {option.label}
          </span>
          {indexLast !== index &&
            <Icon iconName="chevron-right" size={12} className="mx-xsm" />
          }
        </div>
      })}
    </div>
  );
};

Breadcrumb.propTypes = {
  /**
 * List of options
 */
  options: PropTypes.arrayOf(PropTypes.object),
};

Breadcrumb.defaultProps = {
  options: [
    {
      order: 1,
      label: "Label 1"
    },
    {
      order: 2,
      label: "Label 2",
      isDisabled: true
    },
    {
      order: 2,
      label: "Label 2",
      isActive: true,
    },
  ],
};

export default Breadcrumb;